export default __webpack_public_path__ + "static/productOnco-ea8296842b395eceb29749b8e271b990.svg";